import React, { useCallback, useEffect, useState } from "react";
import { oneLineTrim } from "common-tags";

import useThemeService from "../../services/theme-service/ThemeService";
import { configuration } from "../../services/configuration/ConfigurationService";
import Button from "../button/Button";

export function ChangePassword() {
  const { themeClass } = useThemeService();
  const [changePasswordUrl, setChangePasswordUrl] = useState("");

  const composeChangePasswordUrl = useCallback((configurationContent:any) => {
    return oneLineTrim`${configurationContent.authority}/oauth2/v2.0/authorize?
                p=${configurationContent.change_password_policy}
                &client_id=${configurationContent.clientId}
                &nonce=defaultNonce
                &redirect_uri=${configurationContent.redirect_uri}/my-account
                &scope=openid
                &response_type=id_token
                &prompt=login`;
  }, []);

  useEffect(() => {
    configuration.get().then((response:any) => setChangePasswordUrl(composeChangePasswordUrl(response)))
  }, [configuration])

  const redirect = useCallback(() => {
    window.location.href = changePasswordUrl;
  }, [changePasswordUrl]);

  return (
    <Button
      id="change-password"
      onClick={redirect}
      textKey={"general.change-password"}
      className={themeClass(["btn-small"])}
    />
  );
}
